import React, { FC, useCallback, useMemo } from 'react';
import { Button, Result } from 'antd';
import { ResultStatusType } from 'antd/lib/result';
import { useRouter } from 'next/router';

type Props = {
  code?: ResultStatusType;
};

export const ErrorPage: FC<Props> = (props) => {
  const router = useRouter();
  const code: ResultStatusType | undefined = props.code ?? (router.query.code as any);
  const redirectToHome = useCallback(() => {
    window.location.href = '/';
  }, []);
  const getDesc = useMemo(() => {
    switch (code) {
      case '403':
        return 'Sorry, you are not authorized to access this page.';
      case '404':
        return 'Sorry, the page you visited does not exist.';
      case '500':
        return 'Sorry, something went wrong.';
      default:
        return 'Sorry, something went wrong.';
    }
  }, [code]);
  return (
    <Result
      status={code}
      title={code}
      subTitle={getDesc}
      extra={
        <Button type="primary" onClick={redirectToHome}>
          Back Home
        </Button>
      }
    />
  );
};
